import Vue from 'vue';
import Vuex from 'vuex';
import createLoadingPlugin from '../plugins/vuex-loading';
import user from './modules/user';
import company from './modules/company';
import station from './modules/station';
import { dicData } from '../api/common';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    company,
    station,
  },
  plugins: [createLoadingPlugin()],
  state: {
    isMobile: false,
    screenHeight: document.body.clientHeight,
    theme: 'dark',
    layout: 'side',
    systemName: '智能柜系统',
    copyright: '2023 友帮智能柜',
    footerLinks: [
      // { link: 'https://pro.ant.design', name: 'Pro首页' },
      // { link: 'https://github.com/iczer/vue-antd-admin', icon: 'github' },
      // { link: 'https://ant.design', name: 'Ant Design' },
    ],
    multiPage: true,
    dic: [],
  },
  mutations: {
    setDevice(state, isMobile) {
      state.isMobile = isMobile;
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
    setLayout(state, layout) {
      state.layout = layout;
    },
    setMultiPage(state, multiPage) {
      state.multiPage = multiPage;
    },
    SET_DIC(state, data) {
      state.dic = data;
    },
    SET_H(state, height) {
      state.screenHeight = height;
    },
  },
  getters: {
    listTableHeight(state) {
      const h = state.screenHeight - 390;
      return h < 200 ? 200 : h;
    },
    provideType(state) {
      return state.dic.companyProvideType;
    },
    dtuType(state) {
      return state.dic.dutType;
    },
    stationStatus(state) {
      return state.dic.stationStatus;
    },
    cabinetStatus(state) {
      return state.dic.cabinetStatus;
    },
    mainboardTypes(state) {
      return state.dic.mainboardTypes;
    },
    companyType(state) {
      return state.dic.companyTypes;
    },
    partnerStatus(state) {
      return state.dic.partnerStatus;
    },
    methods(state) {
      return state.dic.methods;
    },
    flowTypes(state) {
      return state.dic.flowTypes;
    },
    wTypes(state) {
      return state.dic.wTypes;
    },
    isSuperAdmin(state) {
      return state.user.info.isSuperAdmin;
    },
  },
  actions: {
    async getInitData({ dispatch }) {
      // 获取用户信息
      await dispatch('getCurUserInfo');
      await dispatch('getDicData');
    },
    // 字典数据
    async getDicData({ commit }) {
      const { data } = await dicData();
      commit('SET_DIC', data);
    },
  },
});
